import React from "react";
import { motion } from "framer-motion";
import siteData from "../siteData";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        {/* Decorative name */}
        <div className="footer-name">{siteData.name}</div>

        <div className="footer-social">
          <motion.a
            href={siteData.linkedin}
            aria-label="LinkedIn"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ y: -3, boxShadow: "0 0 25px rgba(0,230,138,0.15)" }}
            whileTap={{ scale: 0.95 }}
          >
            <i className="fa fa-linkedin" />
          </motion.a>
          <motion.a
            href={siteData.github}
            aria-label="GitHub"
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ y: -3, boxShadow: "0 0 25px rgba(0,230,138,0.15)" }}
            whileTap={{ scale: 0.95 }}
          >
            <i className="fa fa-github" />
          </motion.a>
        </div>

        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} {siteData.name}. All rights
          reserved.
        </p>

        <motion.a
          href="#home"
          className="footer-top smoothscroll"
          aria-label="Back to top"
          whileHover={{ y: -3, boxShadow: "0 0 25px rgba(0,230,138,0.15)" }}
        >
          <i className="icon-up-open" />
        </motion.a>
      </div>
    </footer>
  );
}
